





































import * as moment from 'moment'
import Vue, { PropType } from 'vue'

import { store } from 'base/store'
import { Message } from 'base/store/state.interface'

import AttachmentsList from '../attachment/AttachmentsList.vue'

export default Vue.extend({
  components: {
    AttachmentsList
  },
  props: {
    parentMessage: {
      type: Object as PropType<Message | undefined>
    },
    belongsToThread: {
      type: Boolean as PropType<boolean>,
      default: false
    },
    showThreadTopic: {
      type: Boolean as PropType<boolean>,
      default: false
    },
    showAuthorName: {
      type: Boolean as PropType<boolean>,
      default: true
    },
    showDate: {
      type: Boolean as PropType<boolean>,
      default: true
    },
    citationMode: {
      type: Boolean as PropType<boolean>,
      default: false
    },
    message: {
      type: Object as PropType<Message>,
      required: true
    },
    isEditable: {
      type: Boolean as PropType<boolean>,
      required: false,
      default: false
    },
    readonly: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  computed: {
    threadTopicText(): string {
      const message: Message = this.$store.state.message.items[this.message.parent_id!]
      return message ? message.text : ''
    },
    showHeader(): boolean {
      return !this.belongsToThread && (this.citationMode || this.showAuthorName || this.showDate)
    },
    showAvatar(): boolean {
      return this.citationMode || this.showAuthorName || this.belongsToThread
    },
    messageOuterCssClasses(): any {
      return [
        'message',
        {
          'message--hidden': this.message.hidden,
          'message--belongs-to-thread': this.belongsToThread
        }
      ]
    },
    showThreadButtonLabel(): string {
      const numReplies = this.message.messages.length
      return numReplies + ' Antwort' + (numReplies !== 1 ? 'en' : '')
    },
    messageHasReplies(): boolean {
      if (!this.message) return false

      return this.message.messages.length > 0
    },
    latestReplyTimestamp(): string {
      if (!this.message.messages) {
        return ''
      }

      const latestId = Math.max(...this.message.messages)
      const reply: Message = this.$store.state.message.items[latestId]

      if (!reply) {
        return ''
      }

      const ts = moment.unix(reply.ts_create)
      return ts.format('DD.MM.YYYY HH:mm')
    },
    authorInitials(): string {
      const author = store.state.cluster.consumer[this.message.author_id]
      if (!author || !author.firstname || !author.lastname) return ''

      return author.firstname.substring(0, 1) + author.lastname.substring(0, 1)
    },
    authorName(): string {
      const author = store.state.cluster.consumer[this.message.author_id]
      if (!author) return ''

      return author.stdformat_name
    },
    date(): string {
      const creationMoment = moment.unix(this.message.ts_create)
      if (creationMoment.isSame(moment(), 'day') && Math.abs(creationMoment.diff()) <= 1000 * 60 * 60) {
        return moment.duration(creationMoment.diff()).humanize()
      } else {
        return creationMoment.format('HH:mm')
      }
    }
  },
  methods: {
    onMessageClick() {
      if (!this.belongsToThread || !this.message) {
        return
      }
      this.$emit('showMessageThread', this.message.parent_id)
    }
  }
})
